/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.13 public/models/telly.glb 
*/

//react
import React, { useRef, useEffect, Suspense } from "react";

//r3f
import * as THREE from "three";
import { useThree, useFrame } from "@react-three/fiber";
import {
  useGLTF,
  useTexture,
  MeshReflectorMaterial,
  useVideoTexture,
} from "@react-three/drei";
import { degToRad } from "three/src/math/MathUtils.js";
import * as BufferGeometryUtils from "three/addons/utils/BufferGeometryUtils.js";

export function Tele({ onAssetsLoaded, rotationFixed }) {
  useEffect(() => {
    onAssetsLoaded();
  }, []);
  const { scene, nodes } = useGLTF("/models/tele-compressed.glb");
  // //access panel tex
  // const videoTexture = useVideoTexture("/textures/intersect-tv-video-test.mp4");
  const glitchVideoTexture = useVideoTexture(
    "/textures/intersect-logo-glitch-1x1.mp4",
  );
  const textures = useTexture({
    // // access rte
    // accessPanelDiffuse: "/textures/access-panel_Bake1_PBR_Diffuse.webp",
    // accessPanelNormal: "/textures/access-panel_Bake1_PBR_Normal.webp",
    // accessPanelRoughness: "/textures/access-panel_Bake1_PBR_Roughness.webp",

    // // aerial
    // aerialDiffuse: "/textures/aerial_Bake1_PBR_Diffuse.webp",
    // aerialNormal: "/textures/aerial_Bake1_PBR_Normal.webp",
    // aerialRoughness: "/textures/aerial_Bake1_PBR_Roughness.webp",

    // // aerial holder
    // aerialHolderDiffuse: "/textures/aerial-holder_Bake1_PBR_Diffuse.webp",
    // aerialHolderNormal: "/textures/aerial-holder_Bake1_PBR_Normal.webp",
    // aerialHolderRoughness: "/textures/aerial-holder_Bake1_PBR_Roughness.webp",

    // body
    // bodyDiffuse: "/textures/body_Bake1_PBR_Diffuse.webp",
    bodyNormal: "/textures/body_Bake1_PBR_Normal.webp",
    bodyRoughness: "/textures/body_Bake1_PBR_Roughness.webp",

    // // button bottom
    // buttonBottomDiffuse: "/textures/button-bottom_Bake1_PBR_Diffuse.webp",
    // buttonBottomNormal: "/textures/button-bottom_Bake1_PBR_Normal.webp",
    // buttonBottomRoughness: "/textures/button-bottom_Bake1_PBR_Roughness.webp",

    // // button top
    // buttonTopDiffuse: "/textures/button-top_Bake1_PBR_Diffuse.webp",
    // buttonTopNormal: "/textures/button-top_Bake1_PBR_Normal.webp",
    // buttonTopRoughness: "/textures/button-top_Bake1_PBR_Roughness.webp",

    // // buttons channel
    // buttonsChannelDiffuse: "/textures/buttons-channel_Bake1_PBR_Diffuse.webp",
    // buttonsChannelNormal: "/textures/buttons-channel_Bake1_PBR_Normal.webp",
    // buttonsChannelRoughness:
    //   "/textures/buttons-channel_Bake1_PBR_Roughness.webp",

    // // dial guard
    // dialGuardDiffuse: "/textures/dial-guard_Bake1_PBR_Diffuse.webp",
    // dialGuardNormal: "/textures/dial-guard_Bake1_PBR_Normal.webp",
    // dialGuardRoughness: "/textures/dial-guard_Bake1_PBR_Roughness.webp",

    // // dial washers
    // dialWashersDiffuse: "/textures/dial-washers_Bake1_PBR_Diffuse.webp",
    // dialWashersNormal: "/textures/dial-washers_Bake1_PBR_Normal.webp",
    // dialWashersRoughness: "/textures/dial-washers_Bake1_PBR_Roughness.webp",

    // // dials
    // dialsDiffuse: "/textures/dials_Bake1_PBR_Diffuse.webp",
    // dialsNormal: "/textures/dials_Bake1_PBR_Normal.webp",
    // dialsRoughness: "/textures/dials_Bake1_PBR_Roughness.webp",
  });

  // textures.bodyDiffuse.flipY = false;
  // bodyDiffuse.needsUpdate = true;
  textures.bodyNormal.flipY = false;
  // bodyNormal.needsUpdate = true;
  textures.bodyRoughness.flipY = false;
  // bodyRoughness.needsUpdate = true;
  // aerialHolderDiffuse.flipY = false;
  // aerialHolderDiffuse.needsUpdate = true;
  // aerialHolderNormal.flipY = false;
  // aerialHolderNormal.needsUpdate = true;
  // aerialHolderRoughness.flipY = false;
  // aerialHolderRoughness.needsUpdate = true;
  // glitchVideoTexture.repeat.x = -1;
  // glitchVideoTexture.offset.x = 1;
  glitchVideoTexture.repeat.y = -1;
  glitchVideoTexture.offset.y = 1;

  useEffect(() => {
    scene.traverse((child) => {
      if (child.isMesh) {
        const geometry = child.geometry;
        const merged = BufferGeometryUtils.mergeVertices(geometry);
        merged.computeVertexNormals();
        child.geometry = merged;
      }
    });
  }, [scene]);

  const ref = useRef(null);
  const { pointer } = useThree();

  const maxY = Math.PI / 10; // ±18°
  const maxX = Math.PI / 100; // ±1.8°

  useFrame((state, delta) => {
    if (!ref.current) return;
    // if (teleContext !== "reel") return;

    if (!rotationFixed) {
      const targetY = pointer.x * maxY;
      const targetX = -pointer.y * maxX;

      ref.current.rotation.y = THREE.MathUtils.damp(
        ref.current.rotation.y,
        targetY,
        6,
        delta,
      );

      ref.current.rotation.x = THREE.MathUtils.damp(
        ref.current.rotation.x,
        targetX,
        6,
        delta,
      );
    }

    if (rotationFixed !== undefined && typeof rotationFixed === "number") {
      ref.current.rotation.y = degToRad(rotationFixed);
    }

    // if (teleContext === "info" && smallScreen) {
    //   ref.current.rotation.y = 0;
    // }
    // //console.log(ref.current.rotation.x);
    // console.log(ref.current.rotation.y);
  });

  const { camera } = useThree();
  // useEffect(() => {
  camera.lookAt(0, -0.7, 0);
  // }, [camera]);

  useGLTF.preload("/tele.glb");

  const envMapIntensity = 0.2;

  return (
    <>
      <group
        ref={ref}
        position={[0, -3, 0]}
        rotation={[0, -Math.PI * 0.07, 0]}
        dispose={null}
      >
        <mesh
          receiveShadow
          geometry={nodes["dial-washers_Baked"].geometry}
          // material={nodes["dial-washers_Baked"].material}
        >
          <meshStandardMaterial
            color={"#b0b0b0"}
            // map={textures.dialWashersDiffuse}
            // normalMap={textures.dialWashersNormal}
            // roughnessMap={textures.dialWashersRoughness}
            envMapIntensity={envMapIntensity}
          />
        </mesh>
        <mesh
          receiveShadow
          geometry={nodes.body_Baked.geometry}
          // material={nodes.body_Baked.material}
        >
          <meshStandardMaterial
            color={"#D3D3D2"}
            normalMap={textures.bodyNormal}
            roughnessMap={textures.bodyRoughness}
            roughness={0.8}
            envMapIntensity={envMapIntensity}
          />
        </mesh>
        <mesh
          receiveShadow
          flatShading={false}
          geometry={nodes["screen-housing_Baked"].geometry}
          material={nodes["screen-housing_Baked"].material}
        >
          {/* <meshStandardMaterial
            color={"#D3D3D2"}
            // normalMap={textures.bodyNormal}
            // roughnessMap={textures.bodyRoughness}
            roughness={0.8}
            envMapIntensity={envMapIntensity}
          /> */}
          <MeshReflectorMaterial
            color={"#222222"}
            blur={[300, 300]}
            mixBlur={1}
            mixStrength={1}
            mixContrast={1}
            resolution={128}
            mirror={0.2}
            depthScale={0}
            minDepthThreshold={0.2}
            maxDepthThreshold={1}
            depthToBlurRatioBias={0.25}
            reflectorOffset={2}
            envMapIntensity={envMapIntensity}
          />
        </mesh>
        <mesh
          geometry={nodes.screen_Baked.geometry}
          material={nodes.screen_Baked.material}
          position={[0, 0, 0.02]}
          rotation={[0, 0, 0]}
          scale={[1, 1, 1]}
        >
          <meshBasicMaterial
            // color="orange"
            map={glitchVideoTexture}
            // emissive="orange" // the glow color
            // emissiveIntensity={60}
          />
        </mesh>
        {/*flipped screen to fake screen emission*/}
        <mesh
          geometry={nodes.screen_Baked.geometry}
          material={nodes.screen_Baked.material}
          position={[-0.05, 0.25, 4.7]}
          rotation={[0, degToRad(180), 0]}
          scale={[-0.8, 0.9, 1]}
        >
          <meshStandardMaterial
            color="#111"
            emissive="#ffffff"
            emissiveIntensity={40}
            emissiveMap={glitchVideoTexture}
            envMapIntensity={envMapIntensity}
          />
        </mesh>
        <mesh receiveShadow geometry={nodes["access-panel_Baked"].geometry}>
          <meshStandardMaterial
            color={"#161717"}
            // map={textures.accessPanelDiffuse}
            // normalMap={textures.accessPanelNormal}
            // roughnessMap={textures.accessPanelRoughness}
            envMapIntensity={envMapIntensity}
          />
        </mesh>
        {/* <mesh
          castShadow
          receiveShadow
          geometry={nodes.aerial_Baked.geometry}
          // material={nodes.aerial_Baked.material}
          position={[0.148, 0, 0]}
        >
          <meshStandardMaterial
            // map={textures.aerialDiffuse}
            // normalMap={textures.aerialNormal}
            // roughnessMap={textures.aerialRoughness}
            envMapIntensity={envMapIntensity}
          />
        </mesh> */}
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["button-bottom_Baked"].geometry}
          material={nodes["button-bottom_Baked"].material}
        >
          <meshStandardMaterial
            color={"#363636"}
            // map={textures.buttonBottomDiffuse}
            // normalMap={textures.buttonBottomNormal}
            // roughnessMap={textures.buttonBottomRoughness}
            envMapIntensity={envMapIntensity}
          />
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["button-top_Baked"].geometry}
          // material={nodes["button-top_Baked"].material}
        >
          <meshStandardMaterial
            color={"#ff6f16"}
            // map={textures.buttonTopDiffuse}
            // normalMap={textures.buttonTopNormal}
            // roughnessMap={textures.buttonTopRoughness}
            envMapIntensity={envMapIntensity}
          />
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["buttons-channel_Baked"].geometry}
          // material={nodes["buttons-channel_Baked"].material}
        >
          <meshStandardMaterial
            color={"#222222"}
            // map={textures.buttonsChannelDiffuse}
            // normalMap={textures.buttonsChannelNormal}
            // roughnessMap={textures.buttonsChannelRoughness}
            envMapIntensity={envMapIntensity}
          />
        </mesh>
        <mesh
          receiveShadow
          geometry={nodes["dial-guard_Baked"].geometry}
          // material={nodes["dial-guard_Baked"].material}
        >
          <meshStandardMaterial
            color={"#222222"}
            // map={textures.dialGuardDiffuse}
            // normalMap={textures.dialGuardNormal}
            // roughnessMap={textures.dialGuardRoughness}
            envMapIntensity={envMapIntensity}
          />
        </mesh>
        <mesh
          castShadow
          geometry={nodes.dials_Baked.geometry}
          material={nodes.dials_Baked.material}
        >
          <meshStandardMaterial
            color={"#222222"}
            // map={textures.dialsDiffuse}
            // normalMap={textures.dialsNormal}
            // roughnessMap={textures.dialsRoughness}
            envMapIntensity={envMapIntensity}
          />
        </mesh>
        {/* <mesh
          castShadow
          receiveShadow
          geometry={nodes["aerial-holder_Baked"].geometry}
          material={nodes["aerial-holder_Baked"].material}
          position={[1.55, 4.6, -3.616]}
          scale={[0.155, 0.531, 0.155]}
        >
          <meshStandardMaterial
            // map={textures.aerialHolderDiffuse}
            // normalMap={textures.aerialHolderNormal}
            // roughnessMap={textures.aerialHolderRoughness}
            envMapIntensity={envMapIntensity}
          />
        </mesh> */}
      </group>
    </>
  );
}
